import React from "react";
import Spinner from "./common/components/spinner/Spinner";
import Header from "./common/blocks/Header";
import PageCaption from "./common/blocks/PageCaption";
import NotFoundPage from "./common/pages/NotFoundPage/NotFoundPage";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import { checkActiveProfile } from "./modules/Authorization/redux/actions/CheckActiveProfile";
import { restoreLogin } from "./modules/Authorization/redux/actions/RestoreLogin";
import { getUserProfiles } from "./modules/Authorization/redux/actions/ProfileList";
import * as URLs from "./common/constants/systemUrls";

/* TODO Добавить lazy-load или иной способ загрузки по требованию: */

import Employees from "./modules/Employees/Employees";

import Executorship from "./modules/Executorship/Executorship";
import RequestCard from "./modules/Executorship/Request/containers/RequestCard/RequestCard";
// Каталог ТС
import Vehicles from "./modules/Transport/containers/vehicles/Vehicles";
// Добавление ТС
// import AddVehicle from './modules/Transport/containers/addVehicle/AddVehicle';
// Карточка ТС
import VehicleCard from "./modules/Transport/containers/vehicleCard/VehicleCard";

// Карточка предложения
import OfferCard from "./modules/Executorship/Offer/containers/OfferCard/OfferCard";

import OrderCard from "./modules/Executorship/Order/containers/OrderCard/OrderCard";

// таблица доументов
import DocumentsCommon from "./modules/Document/DocumentsCommon";
// карточка документа
// import DocumentCard from './modules/Document/DocumentsCard/containers/DocumentsCard';
// документы заказа
import DocumentsCard from "./modules/Document/DocumentsCard/containers/DocumentsCard";
// таблица Заказчиков
import Customers from "./modules/Customers/containers/Customers/Customers";
// добавление заказчика
// import AddCustomer from './modules/Customers/containers/AddCustomer/AddCustomer';
// карточка заказчика
import CustomerCard from "./modules/Customers/containers/CustomerCard/CustomerCard";
import AddCustomer from "./modules/Customers/containers/AddCustomer/AddCustomer";
// редактирование заказчика
// import EditCustomer from './modules/Customers/containers/EditCustomer/EditCustomer';
// Панель управления
import ControlPanel from "./modules/ControlPanel/containers/ControlPanel";

// Авторизация и роуты
import Authorization from "./modules/Authorization/containers/Authorization/Authorization";
import GlobalAlert from "./modules/Authorization/containers/GlobalAlert/Alert";
import Finances from "./modules/Finance/Finances";
import SystemSettings from "./modules/SystemSettings/SystemSettings";
import AddPerformer from "./modules/SystemSettings/containers/MyPerformers/AddPerformer/AddPerformer";
// import Templates from './modules/Templates/containers/Templates/Templates';
// import AddTemplate from './modules/Templates/containers/TemplateCreation/AddTemplate';
import TemplateCard from "./modules/Templates/containers/TemplateCard/TemplateCard";
import ExecutorCard from "./modules/Executors/containers/ExecutorCard/ExecutorCard";

import { buttonsActions } from "./common/redux/actions";
import PersonList from "./modules/Lists/containers/PersonList/PersonList";
import OfferCreate from "./modules/Executorship/Offer/containers/OfferCreate/OfferCreate";
import FoodProductsList from "./modules/Lists/containers/FoodProductsList/FoodProductsList";
import LandingList from "./modules/Lists/containers/LandingList/LangindList";
import NightPlacementList from "./modules/Lists/containers/NightPlacementList/NightPlacementList";
import OrderDocuments from "./modules/Lists/containers/OrderDocuments/OrderDocuments";
import { clearFilters } from "./common/redux/actions/fieldsActions";
import { clearCustomers } from "./common/redux/actions/profileFieldsActions";

const { getProfileButtons } = buttonsActions;

class App extends React.Component {
  componentDidMount() {
    const doWarn = window.console.warn;
    window.console.warn = (...args) => {
      if (
        typeof args[0] !== "string" ||
        !args[0].startsWith(
          "Warning: componentWillReceiveProps has been renamed"
        )
      )
        doWarn(...args);
    };
    this.props.restoreLogin();
    this.props.checkActiveProfile("activeProfile");
    this.props.getProfileButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.id !== this.props.user.id) {
      this.props.getUserProfiles();
    }
    if (prevProps.activeProfile !== this.props.activeProfile) {
      this.props.clearFilters();
      this.props.clearCustomers();
      this.props.getProfileButtons();
    }
  }

  render() {
    const { pageHasCaption, interfaceBlock, user } = this.props;
    return (
      <div className="App">
        {interfaceBlock && <Spinner />}
        <div id="mainContentContainer">
          <Header user={{ ...user.info }} />
          <div id="mainSheet">
            {pageHasCaption && user.isAuthorized && <PageCaption />}
            <Switch>
              <Route
                exact
                path="/"
                render={props => <Authorization {...props} />}
              />
              <Route
                path={"/" + URLs.AUTHORIZATION}
                render={props => <Authorization {...props} />}
              />
              <Route
                path={"/" + URLs.REQUEST_CARD}
                render={props => <RequestCard {...props} />}
              />
              <Route
                exact
                path={"/" + URLs.ORDER + "/:id(\\d+|add|add_no_freight)"}
                render={props => <OrderCard {...props} />}
              />
              <Route
                exact
                path={"/" + URLs.OFFER + "/:id(\\d+|add)"}
                render={props => <OfferCard {...props} />}
              />
              <Route
                path={"/" + URLs.EXECUTORSHIP}
                render={props => <Executorship {...props} />}
              />
              <Route
                path={"/" + URLs.OFFER_CREATE}
                render={props => <OfferCreate {...props} />}
              />
              <Route
                exact
                path={"/" + URLs.EMPLOYEES + "/:id(\\d+|add)?"}
                render={props => <Employees {...props} />}
              />
              {/* Каталог ТС */}
              <Route
                path={"/" + URLs.VEHICLES}
                render={props => <Vehicles {...props} />}
              />
              {/* Добавление ТС
              <Route
                path={'/' + URLs.ADD_VEHICLE}
                render={props => <AddVehicle {...props} />}
              />*/}
              {/* Карточка ТС */}
              <Route
                path={"/" + URLs.VEHICLE_CARD}
                render={props => <VehicleCard {...props} />}
              />
              {/*<Route*/}
              {/*  path={'/' + URLs.OFFER_EDIT}*/}
              {/*  render={props => <OfferEdit {...props} />}*/}
              {/*/>*/}
              {/* панель управления */}
              <Route
                path={"/" + URLs.CONTROL_PANEL}
                render={props => <ControlPanel {...props} />}
              />
              <Route
                path={"/" + URLs.SYSTEM_SETTINGS + "/templates/:id(\\d+|add)"}
                render={props => <TemplateCard {...props} />}
              />
              <Route
                path={"/" + URLs.SYSTEM_SETTINGS + "/executors/:id(\\d+|add)"}
                render={props => <ExecutorCard {...props} />}
              />
              {/*<Route
                path={'/' + URLs.ADD_TEMPLATE}
                render={props => <AddTemplate {...props} />}
              />
              <Route
                path={'/' + URLs.TEMPLATES}
                render={props => <Templates {...props} />}
              />*/}
              {/* карточка документа
              <Route
                path={'/' + URLs.DOCUMENT_CARD}
                render={props => <DocumentCard {...props} />}
              />*/}
              {/* список документов заказа */}
              <Route
                exact
                path={"/" + URLs.DOCUMENT_BY_ORDERS + "/:id(\\d+)"}
                render={props => <DocumentsCard {...props} />}
              />
              {/* таблица документы */}
              <Route
                path={"/" + URLs.DOCUMENTS}
                render={props => <DocumentsCommon {...props} />}
              />
              {/* добавить заказчика */}
              <Route
                path={"/" + URLs.ADD_CUSTOMER}
                render={props => <AddCustomer {...props} />}
              />
              {/* карточка заказчика */}
              <Route
                path={"/" + URLs.CUSTOMERS + "/:id(\\d+)"}
                render={props => <CustomerCard {...props} />}
              />
              {/* таблица Заказчиков */}
              <Route
                path={"/" + URLs.CUSTOMERS}
                render={props => <Customers {...props} />}
              />
              <Route
                path={"/" + URLs.FINANCES}
                render={props => <Finances {...props} />}
              />
              <Route
                path={"/" + URLs.ADD_PERFORMER}
                render={props => <AddPerformer {...props} />}
              />
              <Route
                path={"/" + URLs.SYSTEM_SETTINGS}
                render={props => <SystemSettings {...props} />}
              />
              <Route
                path={
                  "/" +
                  URLs.ORDER_DOCUMENTS +
                  "/:key(\\bchildren|\\bmed|\\bshippingorg|\\attendants|\\passengers)"
                }
                render={props => <PersonList {...props} />}
              />
              <Route
                path={"/" + URLs.ORDER_DOCUMENTS}
                exact={true}
                render={props => <OrderDocuments {...props} />}
              />
              <Route
                path={"/" + URLs.ORDER_DOCUMENTS + "/landing"}
                render={props => <LandingList {...props} />}
              />
              <Route
                path={"/" + URLs.ORDER_DOCUMENTS + "/food_products"}
                render={props => <FoodProductsList {...props} />}
              />
              <Route
                path={"/" + URLs.ORDER_DOCUMENTS + "/night_placement"}
                render={props => <NightPlacementList {...props} />}
              />
              <Route
                path="*"
                render={props => (
                  <NotFoundPage
                    {...props}
                    errorText="Страница не найдена"
                    errorCaption="404"
                  />
                )}
              />
            </Switch>
          </div>
          <GlobalAlert />
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    pageHasCaption: state.Interface.elements.pageCaption.enabled,
    user: state.Authorization.user,
    interfaceBlock: state.Interface.elements.interfaceBlock,
    activeProfile: state.Authorization.activeProfile.profileId
  }),
  {
    checkActiveProfile,
    restoreLogin,
    getProfileButtons,
    getUserProfiles,
    clearFilters,
    clearCustomers
  }
)(App);
